// @flow
import ChildEvents from './ChildEvents';

export default ChildEvents;
